import { render, staticRenderFns } from "./SendSelectionConfirmationDialog.vue?vue&type=template&id=43dec1ab"
import script from "./SendSelectionConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./SendSelectionConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports